<template>
    <Paper>
      <form class="grid lg:grid-cols-3 lg:gap-44" @submit.prevent="save">
        <div class="grid grid-cols-6 gap-6 col-span-2">
          <text-input class="col-span-6 sm:col-span-3" v-model="user.first_name" name="first_name" label="First name" />
          <text-input class="col-span-6 sm:col-span-3" v-model="user.last_name" name="last_name" label="Last name" />
          <text-input class="col-span-full" v-model="user.email" name="email" label="Email" />
          <text-input class="col-span-full" v-model="user.address1" name="address1" label="Address line 1" />
          <text-input class="col-span-full" v-model="user.address2" name="address2" label="Address line 2" />

          <text-input class="col-span-6 sm:col-span-3" v-model="user.city" name="city" label="City" />
          <text-input class="col-span-6 sm:col-span-3" v-model="user.state" name="state" label="State" />

          <text-input class="col-span-6 sm:col-span-3" v-model="user.county" name="county" label="County" />
          <text-input class="col-span-6 sm:col-span-3" v-model="user.zip" name="zip" label="Zip" />

          <text-input class="col-span-full" v-model="user.country" name="country" label="Country" />
        </div>
        <div class="flex flex-col lg:justify-between">
          <button
              type="button"
              @click="showChangePassword"
              class="border border-gray-500 p-2 uppercase"
          >
            <span class="button-icon icon-edit"></span> Change password
          </button>
          <primary-button>Save changes</primary-button>
        </div>
      </form>

      <vue-modal
          v-if="showModal"
          size="small"
          @close="showModal = false">
        <div slot="header">
          <h3>Change Password</h3>
        </div>
        <div class="space-y-3" slot="body">
          <text-input v-model="changePassword.currentPassword" type="password" name="currentPassword" label="Old password" />
          <text-input v-model="changePassword.newPassword" type="password" name="newPassword" label="New password" />
          <text-input v-model="changePassword.confirmNewPassword" type="password" name="confirmNewPassword" label="Confirm new password" />
        </div>
        <div slot="footer">
          <primary-button @click.native="savePassword()">Change password</primary-button>
        </div>
      </vue-modal>
    </Paper>
</template>

<script>

import Paper from '../Layout/Paper.vue'
import VueButton from '../Shared/VueButton.vue';
import VueModal from '../Shared/VueModal.vue';
import TextInput from "../Form/TextInput";
import WebServices from '../../services/WebServices';
import PrimaryButton from "../Form/PrimaryButton";

export default {

    components: {Paper, PrimaryButton, VueButton, VueModal, TextInput },

    data () {
        return {
            userServices: WebServices("Users"),
            user: { },
            showModal: false,
            changePassword: { }
        }
    },

    created () {
        this.get();
    },
    methods: {
        get () {
            this.userServices
                .get({}, 'Me')
                .then(function(response) {
                    this.user = response.data.data
                }.bind(this));
        },

        save () {

            this.userServices
                .update(this.user)
                .then(() => {

                    swal({
                        title: "Success!",
                        text: "Your account was saved successfully.",
                        type: "success",
                        confirmButtonColor: "#40B572",
                        timer: 2500
                    }, function() {
                        swal.close();
                    }.bind(this));

                }, (response) => {
                    swal({
                        title: "Error", 
                        text: response.data.message, 
                        type: "error",
                        confirmButtonColor: "#40B572",
                        timer: 2500
                    }, function() {
                        swal.close();
                        this.$emit("close");
                    }.bind(this));
                });
        },

        resetChangePassword () {
            this.changePassword = {
                currentPassword: "",
                newPassword: "",
                confirmNewPassword: ""
            };
        },

        showChangePassword () {
            this.resetChangePassword();
            this.showModal = true;
        },

        savePassword () {

            this.userServices
                .store(this.changePassword, 'Me/Password')
                .then(() => {

                    this.resetChangePassword();
                    this.showModal = false;

                }, (response) => {

                    swal({
                        title: "Whoops!",
                        text: response.data.message,
                        type: "warning",
                        confirmButtonColor: "#40B572"
                    });
                });
        }
    }
}

</script>
